const el = {
  common: {
    home: 'Αρχική',
    loading: 'Φόρτωση...',
    and: 'και'
  },
  language: {
    label: 'Γλώσσα',
    english: 'Αγγλικά',
    spanish: 'Ισπανικά',
    greek: 'Ελληνικά'
  },
  header: {
    downloadFreeVersion: 'Λήψη δωρεάν έκδοσης',
    searchPlaceholder: 'Ctrl + K',
    wizard: 'Δημιουργία Εκδήλωσης',
    openNotifications: 'άνοιγμα ειδοποιήσεων',
    notificationsTitle: 'Ειδοποιήσεις',
    markAllReadTooltip: 'Σήμανση όλων ως αναγνωσμένων',
    viewAllNotifications: 'Προβολή όλων'
  },
  menu: {
    navigation: 'Πλοήγηση',
    dashboard: 'Πίνακας',
    events: 'Εκδηλώσεις',
    people: 'Άτομα',
    upgrade: 'Αναβάθμιση',
    administrators: 'Διαχειριστές',
    users: 'Χρήστες',
    scheduled: 'Προγραμματισμένα',
    queue: 'Ουρά',
    queueAll: 'Ουρά - Όλα',
    queueCompleted: 'Ουρά - Ολοκληρωμένα',
    queueNotCompleted: 'Ουρά - Μη ολοκληρωμένα',
    queueOverdue: 'Ουρά - Καθυστερημένα',
    queueEmail: 'Ουρά - Email',
    queueSms: 'Ουρά - SMS',
    queueViber: 'Ουρά - Viber',
    queueTelegram: 'Ουρά - Telegram',
    transactions: 'Συναλλαγές',
    emailTemplates: 'Πρότυπα email',
    eventTemplates: 'Πρότυπα εκδηλώσεων',
    authentication: 'Αυθεντικοποίηση',
    login: 'Σύνδεση',
    register: 'Εγγραφή',
    utilities: 'Εργαλεία',
    typography: 'Τυπογραφία',
    color: 'Χρώμα',
    shadow: 'Σκιά',
    support: 'Υποστήριξη',
    samplePage: 'Δείγμα σελίδας',
    documentation: 'Τεκμηρίωση'
  },
  footer: {
    rightsReserved: 'Με επιφύλαξη παντός δικαιώματος',
    hireUs: 'Προσλάβετε μας',
    license: 'Άδεια',
    terms: 'Όροι',
    figmaDesignSystem: 'Σύστημα σχεδίασης Figma'
  },
  dashboard: {
    title: 'Πίνακας',
    apiHealth: 'Κατάσταση API',
    checking: 'Έλεγχος...',
    currentUser: 'Τρέχων χρήστης',
    signedIn: 'Συνδεδεμένος',
    signedInAccount: 'Συνδεδεμένος λογαριασμός',
    userRole: 'Χρήστης',
    sessionInvalid: 'Μη έγκυρη σύνοδος',
    loginAgain: 'Παρακαλώ συνδεθείτε ξανά',
    totalOrder: 'Σύνολο παραγγελιών',
    totalSales: 'Συνολικές πωλήσεις',
    totalEvents: 'Σύνολο εκδηλώσεων',
    totalEventsDesc: 'Όλες οι εκδηλώσεις σας',
    totalPeople: 'Σύνολο ατόμων',
    totalPeopleDesc: 'Ενεργά άτομα στη λίστα σας',
    nextEvent: 'Επόμενη εκδήλωση',
    noUpcomingEvent: 'Δεν υπάρχουν επερχόμενες εκδηλώσεις',
    today: 'Σήμερα',
    days: 'ημέρες',
    incomeOverview: 'Επισκόπηση εσόδων',
    thisWeekStatistics: 'Στατιστικά εβδομάδας',
    recentOrders: 'Πρόσφατες παραγγελίες',
    recentAnswers: 'Πρόσφατες απαντήσεις',
    recentAnswersTable: {
      event: 'Εκδήλωση',
      name: 'Ονοματεπώνυμο',
      email: 'Email',
      phone: 'Τηλέφωνο',
      countPerson: 'Άτομα',
      status: 'Κατάσταση',
      noData: 'Δεν υπάρχουν απαντήσεις ακόμα.',
      statusAttending: 'Παρών',
      statusDeclined: 'Αρνήθηκε',
      statusMaybe: 'Ίσως',
      statusPending: 'Σε αναμονή'
    },
    exportCsv: 'Εξαγωγή CSV',
    exportExcel: 'Εξαγωγή Excel',
    printTable: 'Εκτύπωση πίνακα',
    analyticsReport: 'Αναλυτική έκθεση',
    weekly: 'Εβδομαδιαία',
    monthly: 'Μηνιαία',
    yearly: 'Ετήσια',
    financeGrowth: 'Οικονομική ανάπτυξη εταιρείας',
    expensesRatio: 'Αναλογία εξόδων',
    businessRiskCases: 'Επιχειρηματικοί κίνδυνοι',
    low: 'Χαμηλός',
    transactionHistory: 'Ιστορικό συναλλαγών',
    recentNotifications: 'Πρόσφατες ειδοποιήσεις',
    noNotifications: 'Δεν υπάρχουν ειδοποιήσεις',
    justNow: 'Μόλις τώρα',
    minutesAgo: 'Πριν {{count}}λ',
    hoursAgo: 'Πριν {{count}}ω',
    daysAgo: 'Πριν {{count}}η',
    helpSupportChat: 'Βοήθεια & Υποστήριξη',
    typicalReply: 'Συνήθης απάντηση εντός 5 λεπτών',
    needHelp: 'Χρειάζεστε βοήθεια;',
    financeOverview: 'Οικονομική Επισκόπηση',
    income: 'Έσοδα',
    expenses: 'Έξοδα',
    month: 'Μήνας',
    week: 'Εβδομάδα',
    noFinanceData: 'Προσθέστε οικονομικά δεδομένα στα events σας για να δείτε το γράφημα',
    goToEvents: 'Μετάβαση σε Events',
    welcome: {
      heading: 'Καλώς ήρθατε στο EventList',
      subtitle: 'Όλα όσα χρειάζεστε για να σχεδιάσετε και να διαχειριστείτε τις εκδηλώσεις σας — προσκλήσεις, καλεσμένοι, τραπέζια και οικονομικά — σε ένα μέρος.',
      cta: 'Δημιουργήστε την πρώτη σας εκδήλωση',
      step1Title: 'Δημιουργία εκδήλωσης',
      step1Desc: 'Ορίστε την εκδήλωσή σας με όνομα, ημερομηνία, τοποθεσία και όλες τις λεπτομέρειες.',
      step2Title: 'Προσθήκη καλεσμένων',
      step2Desc: 'Δημιουργήστε τη λίστα καλεσμένων σας και στείλτε όμορφες προσκλήσεις μέσω email.',
      step3Title: 'Διαχείριση τραπεζιών',
      step3Desc: 'Αναθέστε καλεσμένους σε τραπέζια και οργανώστε τη διάταξη καθισμάτων εύκολα.',
      step4Title: 'Παρακολούθηση οικονομικών',
      step4Desc: 'Καταγράψτε έσοδα και έξοδα για να διατηρείτε τον προϋπολογισμό της εκδήλωσής σας υπό έλεγχο.'
    }
  },
  upgradePage: {
    title: 'Αναβάθμιση σε Premium',
    subtitle: 'Ξεκλειδώστε προηγμένες δυνατότητες για την ομάδα σας με ένα μοναδικό πλάνο Premium.',
    discountBadge: 'Εξοικονόμηση 30%',
    returnHint: 'Μετά από επιτυχημένη πληρωμή, θα επιστρέψετε αυτόματα στη σελίδα ευχαριστιών.',
    month: 'μήνα',
    year: 'έτος',
    billingMonthly: 'Μηνιαία',
    billingYearly: 'Ετήσια',
    billedAnnually: 'Χρέωση EUR {{price}} / έτος',
    yearlyDiscount: '30% έκπτωση στο ετήσιο πλάνο',
    choosePlan: 'Επιλογή πλάνου',
    processing: 'Ανακατεύθυνση στη σελίδα πληρωμής...',
    packages: {
      premium: 'Premium'
    },
    features: {
      unlimitedCustomers: 'Αποστολή σε απεριόριστους πελάτες',
      unlimitedEvents: 'Απεριόριστες εκδηλώσεις και προσκλήσεις',
      emailSmsViberTelegram: 'Κανάλια Email, SMS, Viber και Telegram',
      advancedAnalytics: 'Προηγμένα στατιστικά και παρακολούθηση αποστολών',
      prioritySupport: 'Υποστήριξη προτεραιότητας με ταχύτερη απόκριση',
      multiTeamAccess: 'Πρόσβαση πολλών ομάδων και διαχείριση ρόλων'
    },
    errors: {
      loadCatalog: 'Αδυναμία φόρτωσης πλάνων χρέωσης.',
      planUnavailable: 'Αυτό το πλάνο δεν είναι διαθέσιμο προσωρινά. Δοκιμάστε ξανά.',
      checkoutFailed: 'Αποτυχία δημιουργίας συνεδρίας πληρωμής. Δοκιμάστε ξανά.'
    }
  },
  upgradeThankYou: {
    title: 'Ευχαριστούμε για την πληρωμή',
    subtitle: 'Η επιβεβαίωση του πακέτου σας βρίσκεται σε εξέλιξη. Μπορείτε να συνεχίσετε στο dashboard.',
    processing: 'Γίνεται επεξεργασία της επιβεβαίωσης πληρωμής...',
    success: 'Η πληρωμή ολοκληρώθηκε επιτυχώς. Τα προνόμια του πλάνου σας είναι ενεργά.',
    missingPaymentReference: 'Δεν βρέθηκε αναφορά πληρωμής στο URL επιστροφής.',
    backToUpgrade: 'Πίσω στην Αναβάθμιση',
    goToDashboard: 'Μετάβαση στο Dashboard',
    errors: {
      completeFailed: 'Αποτυχία επιβεβαίωσης πληρωμής. Επικοινωνήστε με υποστήριξη αν έχετε χρεωθεί.'
    }
  },
  mobileCheckoutResult: {
    successTitle: 'Η πληρωμή ολοκληρώθηκε',
    successMessage: 'Η πληρωμή σας ολοκληρώθηκε. Μπορείτε να κλείσετε αυτή τη σελίδα και να επιστρέψετε στην εφαρμογή.',
    failedTitle: 'Η πληρωμή δεν ολοκληρώθηκε',
    failedMessage: 'Η πληρωμή σας δεν ολοκληρώθηκε ή ακυρώθηκε. Μπορείτε να κλείσετε αυτή τη σελίδα και να επιστρέψετε στην εφαρμογή.',
    pendingTitle: 'Η πληρωμή καταχωρήθηκε',
    pendingMessage: 'Μπορείτε να κλείσετε αυτή τη σελίδα και να επιστρέψετε στην εφαρμογή.'
  },
  eventsPage: {
    title: 'Εκδηλώσεις',
    createNewEvent: 'Δημιουργία νέας εκδήλωσης',
    loadingEvents: 'Φόρτωση εκδηλώσεων...',
    searchLabel: 'Αναζήτηση',
    searchPlaceholder: 'Αναζήτηση με τίτλο, τύπο, χώρο ή διεύθυνση',
    pageSize: 'Μέγεθος σελίδας',
    results: 'Εμφανίζονται {{shown}} από {{total}} εκδηλώσεις',
    noEvents: 'Δεν υπάρχουν εκδηλώσεις ακόμα. Δημιουργήστε την πρώτη σας εκδήλωση.',
    noEventsMatchSearch: 'Δεν βρέθηκαν εκδηλώσεις για την αναζήτησή σας.',
    noEventsMatchFilters: 'Δεν βρέθηκαν εκδηλώσεις για τα επιλεγμένα φίλτρα μεθόδων αποστολής.',
    edit: 'Επεξεργασία',
    view: 'Προβολή',
    createEvent: 'Δημιουργία εκδήλωσης',
    editEvent: 'Επεξεργασία εκδήλωσης',
    viewEvent: 'Προβολή εκδήλωσης',
    save: 'Αποθήκευση',
    saveChanges: 'Αποθήκευση αλλαγών',
    cancel: 'Ακύρωση',
    close: 'Κλείσιμο',
    guestsTitle: 'Καλεσμένοι',
    loadingGuests: 'Φόρτωση καλεσμένων...',
    noGuests: 'Δεν βρέθηκαν καλεσμένοι για αυτή την εκδήλωση.',
    eventFallback: 'Εκδήλωση',
    table: {
      actions: 'Ενέργειες',
      edit: 'Επεξεργασία',
      title: 'Τίτλος',
      occasion: 'Περίσταση',
      eventType: 'Τύπος εκδήλωσης',
      status: 'Κατάσταση',
      sendProviders: 'Μέθοδοι αποστολής',
      scheduledLocal: 'Προγραμματισμένο (τοπική ώρα)',
      createdLocal: 'Δημιουργία (τοπική ώρα)',
      venue: 'Χώρος',
      guests: 'Καλεσμένοι'
    },
    actions: 'Ενέργειες',
    manageTables: 'Τραπέζια',
    status: {
      readyToSend: 'Έτοιμο για αποστολή',
      sending: 'Αποστολή σε εξέλιξη',
      sent: 'Στάλθηκε'
    },
    sendDateMode: {
      immediately: 'Άμεσα',
      scheduled: 'Προγραμματισμένο'
    },
    details: {
      title: 'Στοιχεία εκδήλωσης',
      status: 'Κατάσταση',
      sendDateMode: 'Τρόπος αποστολής',
      templateName: 'Όνομα προτύπου',
      totalGuests: 'Συνολικοί καλεσμένοι'
    },
    form: {
      title: 'Τίτλος',
      occasionType: 'Τύπος περίστασης',
      eventType: 'Τύπος εκδήλωσης',
      scheduledDateTime: 'Ημερομηνία και ώρα',
      venue: 'Χώρος',
      address: 'Διεύθυνση',
      timeZone: 'Ζώνη ώρας',
      defaultLanguage: 'Προεπιλεγμένη γλώσσα',
      sendProviders: 'Μέθοδοι αποστολής',
      replyBeforeDays: 'Προθεσμία απάντησης (ημέρες πριν την εκδήλωση)',
      replyBeforeDaysHelp: 'Αριθμός ημερών πριν την εκδήλωση που πρέπει να απαντήσουν οι καλεσμένοι. Αφήστε κενό για καμία προθεσμία.'
    },
    filters: {
      status: 'Φίλτρο ανά κατάσταση',
      allStatuses: 'Όλες οι καταστάσεις',
      sendProvider: 'Φίλτρο ανά μέθοδο αποστολής',
      allSendProviders: 'Όλες οι μέθοδοι αποστολής',
      sortBySendProvider: 'Ταξινόμηση ανά μέθοδο αποστολής',
      showFilters: 'Εμφάνιση φίλτρων',
      hideFilters: 'Απόκρυψη φίλτρων',
      none: 'Χωρίς ταξινόμηση',
      ascending: 'Α έως Ω',
      descending: 'Ω έως Α',
      tableView: 'Προβολή πίνακα',
      cardView: 'Προβολή καρτών'
    },
    card: {
      template: 'Πρότυπο',
      templatePreview: 'Προεπισκόπηση προτύπου',
      noImage: 'Χωρίς εικόνα προεπισκόπησης'
    },
    pagination: {
      previous: 'Προηγούμενη',
      next: 'Επόμενη',
      goToPage: 'Μετάβαση σε σελίδα',
      pageOf: 'Σελίδα {{page}} από {{totalPages}}'
    },
    eventTypeOptions: {
      other: 'Άλλο',
      wedding: 'Γάμος',
      birthday: 'Γενέθλια',
      conference: 'Συνέδριο',
      meeting: 'Συνάντηση',
      party: 'Πάρτι'
    },
    backToEvents: 'Επιστροφή στις εκδηλώσεις',
    guestsTable: {
      name: 'Όνομα',
      email: 'Email',
      phone: 'Τηλέφωνο',
      countPerson: 'Αριθμός',
      preferredLanguage: 'Γλώσσα',
      status: 'Κατάσταση',
      url: 'Δημόσιο URL',
      copyUrl: 'Αντιγραφή URL',
      copyWishlistUrl: 'Αντιγραφή Λίστας Επιθυμιών',
      copied: 'Αντιγράφηκε',
      resend: 'Επαναποστολή',
      resending: 'Γίνεται επαναποστολή...',
      resendSuccess: 'Η πρόσκληση επαναστάλθηκε στον/στην {{name}}.',
      log: 'Ιστορικό',
      lastAnswerLocal: 'Τελευταία απάντηση',
      tableNumber: 'Τραπέζι',
      logHistoryTitle: 'Ιστορικό απαντήσεων καλεσμένου',
      logAction: 'Ενέργεια',
      logActionResponded: 'Ο καλεσμένος απάντησε',
      logDateLocal: 'Ημερομηνία (τοπική ώρα)',
      loadingLog: 'Φόρτωση ιστορικού απαντήσεων...',
      logFilter: 'Φίλτρο',
      logFilterToday: 'Σήμερα',
      logFilterLast7Days: 'Τελευταίες 7 ημέρες',
      logFilterAll: 'Όλα',
      noLogEntries: 'Δεν υπάρχουν ακόμη καταχωρίσεις απάντησης.',
      quickViewTitle: 'Στοιχεία καλεσμένου',
      rsvpStatus: 'Κατάσταση RSVP',
      invitationCode: 'Κωδικός πρόσκλησης',
      scanCode: 'Κωδικός σάρωσης',
      statusChanged: 'Η κατάσταση ενημερώθηκε για {{name}}.',
      countPersonChanged: 'Ο αριθμός ατόμων ενημερώθηκε για {{name}}.',
      checkedIn: 'Εισήλθε',
      addGuest: 'Προσθήκη Καλεσμένου',
      addGuestTitle: 'Προσθήκη Νέου Καλεσμένου',
      addGuestSuccess: 'Ο/Η {{name}} προστέθηκε ως καλεσμένος/η.',
      sendToUnsent: 'Αποστολή σε Μη Σταλμένους',
      sendToUnsentHint: 'Χρησιμοποιήστε "Αποστολή σε Μη Σταλμένους" για να στείλετε προσκλήσεις σε καλεσμένους που προστέθηκαν αλλά δεν έχουν λάβει μήνυμα ακόμα.',
      sendToUnsentSuccess: 'Οι προσκλήσεις στάλθηκαν σε {{count}} καλεσμένο(ους) χωρίς αποστολή.',
      allAlreadySent: 'Σε όλους τους καλεσμένους έχει ήδη σταλεί πρόσκληση.',
      addFromContacts: 'Από Επαφές',
      addFromContactsTitle: 'Προσθήκη Καλεσμένων από Επαφές',
      addFromContactsSuccess: '{{count}} επαφή(ές) προστέθηκαν ως καλεσμένοι.',
      searchContactsPlaceholder: 'Αναζήτηση με όνομα, email ή τηλέφωνο',
      noContactsMatch: 'Δεν βρέθηκαν επαφές που ταιριάζουν.',
      noContactsAvailable: 'Όλες οι επαφές έχουν ήδη προστεθεί σε αυτό το event.',
      contactsAvailable: '{{count}} διαθέσιμες επαφές ({{selected}} επιλεγμένες)',
      addSelected: 'Προσθήκη {{count}} Επιλεγμένων',
      remove: 'Αφαίρεση',
      removeGuestTitle: 'Αφαίρεση Καλεσμένου',
      removeGuestConfirm: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον/την {{name}} από αυτό το event; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
      removeGuestSuccess: 'Ο/Η {{name}} αφαιρέθηκε από αυτό το event.'
    },
    rsvp: {
      accepted: 'Αποδοχή',
      rejected: 'Απόρριψη',
      maybe: 'Ίσως',
      pending: 'Σε εκκρεμότητα'
    },
    errors: {
      backendUnavailable:
        'Αδυναμία πρόσβασης στο backend API στο {{baseUrl}}. Ξεκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      loadEvents: 'Αδυναμία φόρτωσης εκδηλώσεων αυτή τη στιγμή.',
      loadEventDetails: 'Αποτυχία φόρτωσης λεπτομερειών εκδήλωσης.',
      loadGuests: 'Αποτυχία φόρτωσης καλεσμένων.',
      loadGuestLog: 'Αποτυχία φόρτωσης ιστορικού απαντήσεων καλεσμένου.',
      createEvent: 'Αποτυχία δημιουργίας εκδήλωσης.',
      updateEvent: 'Αποτυχία ενημέρωσης εκδήλωσης.',
      resendInvitation: 'Αποτυχία επαναποστολής πρόσκλησης.',
      resendTemplateNotFound: 'Δεν βρέθηκε συμβατό πρότυπο για τον καλεσμένο.',
      changeStatus: 'Αποτυχία αλλαγής κατάστασης καλεσμένου.',
      changeCountPerson: 'Αποτυχία ενημέρωσης αριθμού ατόμων.',
      addGuest: 'Αποτυχία προσθήκης καλεσμένου.',
      removeGuest: 'Αποτυχία αφαίρεσης καλεσμένου.'
    },
    validation: {
      titleMax: 'Ο τίτλος πρέπει να έχει έως 120 χαρακτήρες',
      titleRequired: 'Ο τίτλος είναι υποχρεωτικός',
      occasionTypeMax: 'Ο τύπος περίστασης πρέπει να έχει έως 60 χαρακτήρες',
      occasionTypeRequired: 'Ο τύπος περίστασης είναι υποχρεωτικός',
      scheduledAtRequired: 'Η ημερομηνία και ώρα είναι υποχρεωτικές',
      venueMax: 'Ο χώρος πρέπει να έχει έως 160 χαρακτήρες',
      venueRequired: 'Ο χώρος είναι υποχρεωτικός',
      addressMax: 'Η διεύθυνση πρέπει να έχει έως 240 χαρακτήρες',
      addressRequired: 'Η διεύθυνση είναι υποχρεωτική',
      timeZoneMax: 'Η ζώνη ώρας πρέπει να έχει έως 100 χαρακτήρες',
      timeZoneRequired: 'Η ζώνη ώρας είναι υποχρεωτική',
      defaultLanguageMax: 'Η γλώσσα πρέπει να έχει έως 10 χαρακτήρες',
      defaultLanguageRequired: 'Η προεπιλεγμένη γλώσσα είναι υποχρεωτική',
      sendProviderMax: 'Η μέθοδος αποστολής πρέπει να έχει έως 40 χαρακτήρες',
      sendProviderRequired: 'Η μέθοδος αποστολής είναι υποχρεωτική'
    }
  },
  tablesPage: {
    title: 'Τραπέζια',
    backToEvents: 'Επιστροφή στις εκδηλώσεις',
    backToTables: 'Επιστροφή στα τραπέζια',
    print: 'Εκτύπωση',
    printViewTitle: 'Προβολή εκτύπωσης τραπεζιών',
    printViewSubtitle: 'Επισκόπηση καθισμάτων για εκτύπωση',
    eventDetails: 'Στοιχεία εκδήλωσης',
    detailEventName: 'Όνομα εκδήλωσης',
    detailEventType: 'Τύπος εκδήλωσης',
    detailDateLocal: 'Ημερομηνία (τοπική)',
    detailVenue: 'Χώρος',
    detailAddress: 'Διεύθυνση',
    detailTimeZone: 'Ζώνη ώρας',
    detailDefaultLanguage: 'Προεπιλεγμένη γλώσσα',
    detailAssignedGuests: 'Ανατεθειμένοι καλεσμένοι',
    detailAssignedPersons: 'Ανατεθειμένα άτομα',
    detailTotalTables: 'Σύνολο τραπεζιών',
    noAssignedTables: 'Δεν υπάρχουν ακόμα αναθέσεις τραπεζιών.',
    tableGuestCount: '{{count}} καλεσμένοι',
    tablePersonCount: '{{count}} άτομα',
    loading: 'Φόρτωση τραπεζιών εκδήλωσης...',
    eventFallback: 'Εκδήλωση',
    summary: 'Καλεσμένοι: {{totalGuests}}. Αναθέσεις: {{assignedGuests}}. Χωρίς τραπέζι: {{unassignedGuests}}.',
    capacityLabel: 'Άτομα ανά τραπέζι',
    countModeLabel: 'Μέτρηση καλεσμένων για πρόταση',
    tableCountLabel: 'Τραπέζια προς εμφάνιση',
    rsvpFilterLabel: 'Φίλτρο καλεσμένων ανά RSVP',
    hardLockLabel: 'Αυστηρό κλείδωμα χωρητικότητας',
    hardLockOn: 'Ενεργό (μπλοκάρει drop σε υπέρβαση)',
    hardLockOff: 'Απενεργό (επιτρέπει προσωρινή υπέρβαση)',
    applyRecommended: 'Χρήση προτεινόμενου',
    autoAssign: 'Αυτόματη ανάθεση',
    clear: 'Καθαρισμός αναθέσεων',
    save: 'Αποθήκευση τραπεζιών',
    saving: 'Αποθήκευση...',
    recommendation: '{{guests}} καλεσμένοι / {{capacity}} ανά τραπέζι = {{tables}} απαιτούμενα τραπέζια.',
    occupancy: '{{count}} / {{capacity}}',
    overCapacityWarning: 'Υπέρβαση χωρητικότητας για τραπέζι(α): {{tables}}. Μειώστε κάθε τραπέζι σε {{capacity}} καλεσμένους max.',
    lockBlocked: 'Δεν επιτρέπεται drop στο τραπέζι {{tableNumber}} επειδή είναι ήδη στη χωρητικότητα ({{capacity}}).',
    declinedBlocked: 'Καλεσμένοι με κατάσταση RSVP Απόρριψη δεν μπορούν να ανατεθούν σε τραπέζια.',
    pastEventLocked: 'Οι αναθέσεις τραπεζιών είναι κλειδωμένες επειδή η εκδήλωση έχει ήδη περάσει.',
    unassigned: 'Καλεσμένοι χωρίς τραπέζι',
    emptyUnassigned: 'Όλοι οι καλεσμένοι έχουν τραπέζι.',
    tableTitle: 'Τραπέζι {{tableNumber}}',
    dropHint: 'Σύρετε καλεσμένους εδώ',
    filteredViewHint: 'Εμφανίζονται {{shown}} από {{total}} καλεσμένους για το τρέχον φίλτρο.',
    rsvpFilter: {
      all: 'Όλες οι καταστάσεις RSVP',
      attending: 'Αποδοχή',
      maybe: 'Ίσως',
      pending: 'Εκκρεμεί',
      declined: 'Απόρριψη'
    },
    countMode: {
      all: 'Όλοι εκτός αρνήσεων',
      attendingOnly: 'Μόνο αποδοχές'
    },
    success: {
      saved: 'Αποθηκεύτηκαν τραπέζια για {{count}} καλεσμένους.'
    },
    errors: {
      backendUnavailable:
        'Αδυναμία πρόσβασης στο backend API στο {{baseUrl}}. Ξεκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      missingEventId: 'Λείπει το id εκδήλωσης από τη διαδρομή.',
      load: 'Αποτυχία φόρτωσης τραπεζιών εκδήλωσης.',
      save: 'Αποτυχία αποθήκευσης αναθέσεων τραπεζιών.'
    },
    premiumGate: {
      title: 'Λειτουργία Premium',
      description: 'Η διαχείριση τραπεζιών είναι διαθέσιμη μόνο σε Premium συνδρομητές. Αναβαθμίστε το πλάνο σας για πρόσβαση στις αναθέσεις καθισμάτων.',
      upgrade: 'Αναβάθμιση σε Premium'
    },
    invitationGate: {
      title: 'Οι προσκλήσεις δεν έχουν σταλεί ακόμα',
      description: 'Η διαχείριση τραπεζιών θα είναι διαθέσιμη μόλις σταλούν οι προσκλήσεις. Στείλτε πρώτα τις προσκλήσεις και μετά θα μπορείτε να διαχειριστείτε τις αναθέσεις τραπεζιών.'
    }
  },
  wizardPage: {
    title: 'Οδηγός δημιουργίας εκδήλωσης',
    loading: 'Φόρτωση δεδομένων οδηγού...',
    steps: {
      createEvent: 'Δημιουργία εκδήλωσης',
      selectTemplate: 'Επιλογή προτύπου',
      selectPeople: 'Επιλογή ατόμων',
      preview: 'Προεπισκόπηση',
      confirmAndSend: 'Επιβεβαίωση και αποστολή'
    },
    actions: {
      backToEvents: 'Επιστροφή στις εκδηλώσεις',
      back: 'Πίσω',
      next: 'Επόμενο'
    },
    form: {
      title: 'Τίτλος εκδήλωσης',
      occasionType: 'Τύπος περίστασης',
      eventType: 'Τύπος εκδήλωσης',
      status: 'Κατάσταση',
      scheduledDateTime: 'Προγραμματισμένη ημερομηνία και ώρα',
      sendDateMode: 'Ημερομηνία αποστολής',
      sendDateTime: 'Ημερομηνία και ώρα αποστολής',
      sendProviders: 'Μέθοδοι αποστολής',
      venue: 'Χώρος',
      address: 'Διεύθυνση',
      defaultLanguage: 'Προεπιλεγμένη γλώσσα',
      timeZone: 'Ζώνη ώρας',
      replyBeforeDays: 'Προθεσμία απάντησης (ημέρες πριν την εκδήλωση)',
      replyBeforeDaysHelp: 'Αριθμός ημερών πριν την εκδήλωση που πρέπει να απαντήσουν οι καλεσμένοι. Αφήστε κενό για καμία προθεσμία.'
    },
    status: {
      readyToSend: 'Έτοιμο για αποστολή',
      sending: 'Αποστολή σε εξέλιξη',
      sent: 'Στάλθηκε'
    },
    sendDateMode: {
      immediately: 'Άμεσα',
      scheduled: 'Προγραμματισμός ημερομηνίας και ώρας'
    },
    templates: {
      noPhoto: 'Χωρίς φωτογραφία',
      previewAlt: 'Εικόνα προεπισκόπησης προτύπου',
      language: 'Γλώσσα',
      photoSchema: 'Σχήμα φωτογραφίας: 200px x 200px',
      filterEventType: 'Φίλτρο ανά τύπο εκδήλωσης',
      filterLanguage: 'Φίλτρο ανά γλώσσα',
      all: 'Όλα',
      other: 'Άλλο',
      noResultsForFilters: 'Δεν βρέθηκαν πρότυπα για τα επιλεγμένα φίλτρα.'
    },
    table: {
      select: 'Επιλογή',
      action: 'Ενέργεια',
      name: 'Όνομα',
      email: 'Email',
      phone: 'Τηλέφωνο',
      countPerson: 'Αριθμός ατόμων'
    },
    people: {
      createPerson: 'Δημιουργία ατόμου',
      importAvailability: 'Εισαγωγή διαθεσιμότητας (Excel)',
      selectAll: 'Επιλογή όλων',
      deselectAll: 'Αποεπιλογή όλων',
      editPerson: 'Γρήγορη επεξεργασία',
      dialogTitle: 'Δημιουργία ατόμου',
      editDialogTitle: 'Επεξεργασία ατόμου',
      fullNameLabel: 'Ονοματεπώνυμο',
      emailLabel: 'Email',
      phoneLabel: 'Τηλέφωνο',
      countPersonLabel: 'Αριθμός ατόμων',
      cancel: 'Ακύρωση',
      save: 'Αποθήκευση',
      create: 'Δημιουργία',
      saving: 'Αποθήκευση...',
      creating: 'Δημιουργία...',
      success: {
        personCreated: 'Το άτομο δημιουργήθηκε και επιλέχθηκε επιτυχώς.',
        personUpdated: 'Το άτομο ενημερώθηκε επιτυχώς.'
      },
      errors: {
        createPerson: 'Αποτυχία δημιουργίας ατόμου.',
        updatePerson: 'Αποτυχία ενημέρωσης ατόμου.',
        fullNameEmailRequired: 'Το ονοματεπώνυμο και το email είναι υποχρεωτικά.',
        invalidEmail: 'Εισαγάγετε μια έγκυρη διεύθυνση email.'
      }
    },
    preview: {
      eventSummary: 'Σύνοψη εκδήλωσης',
      title: 'Τίτλος',
      occasion: 'Περίσταση',
      eventType: 'Τύπος εκδήλωσης',
      when: 'Πότε',
      status: 'Κατάσταση',
      sendDateMode: 'Ημερομηνία αποστολής',
      sendDateTime: 'Ημερομηνία και ώρα αποστολής',
      venue: 'Χώρος',
      address: 'Διεύθυνση',
      timeZone: 'Ζώνη ώρας',
      defaultLanguage: 'Προεπιλεγμένη γλώσσα',
      sendProviders: 'Μέθοδοι αποστολής',
      selectedTemplate: 'Επιλεγμένο πρότυπο',
      previewInvitation: 'Προεπισκόπηση πρόσκλησης',
      closePreview: 'Κλείσιμο προεπισκόπησης',
      noTemplateSelected: 'Δεν επιλέχθηκε πρότυπο',
      recipients: 'Παραλήπτες',
      peopleSelected: '{{count}} άτομα επιλεγμένα',
      countPersonSelected: '{{count}} συνολικοί παρευρισκόμενοι επιλεγμένοι'
    },
    confirm: {
      description: 'Έτοιμο για δημιουργία εκδήλωσης, προσθήκη επιλεγμένων ατόμων ως καλεσμένων και αποστολή προσκλήσεων.',
      confirmAndSend: 'Επιβεβαίωση και αποστολή',
      eventId: 'Id εκδήλωσης'
    },
    warnings: {
      noTemplates: 'Δεν βρέθηκαν πρότυπα πρόσκλησης. Δημιουργήστε τουλάχιστον ένα πρότυπο για να σταλούν προσκλήσεις.',
      noPeople: 'Δεν βρέθηκαν άτομα. Προσθέστε άτομα πρώτα από τη σελίδα Άτομα.'
    },
    validation: {
      titleRequired: 'Ο τίτλος εκδήλωσης είναι υποχρεωτικός.',
      occasionTypeRequired: 'Ο τύπος περίστασης είναι υποχρεωτικός.',
      eventTypeRequired: 'Ο τύπος εκδήλωσης είναι υποχρεωτικός.',
      scheduledRequired: 'Η ημερομηνία και η ώρα είναι υποχρεωτικές.',
      sendDateRequired: 'Η ημερομηνία και η ώρα αποστολής είναι υποχρεωτικές όταν επιλέγεται προγραμματισμός.',
      venueRequired: 'Ο χώρος είναι υποχρεωτικός.',
      addressRequired: 'Η διεύθυνση είναι υποχρεωτική.',
      timeZoneRequired: 'Η ζώνη ώρας είναι υποχρεωτική.',
      sendProviderRequired: 'Η μέθοδος αποστολής είναι υποχρεωτική.',
      templateRequired: 'Επιλέξτε πρότυπο.',
      peopleRequired: 'Επιλέξτε τουλάχιστον ένα άτομο.'
    },
    errors: {
      backendUnavailable: 'Αδυναμία πρόσβασης στο backend API. Βεβαιωθείτε ότι το EventList.Api εκτελείται.',
      loadTemplates: 'Αποτυχία φόρτωσης προτύπων.',
      loadPeople: 'Αποτυχία φόρτωσης ατόμων.',
      loadWizardData: 'Αποτυχία φόρτωσης δεδομένων οδηγού.',
      createEvent: 'Αποτυχία δημιουργίας εκδήλωσης.',
      updateEvent: 'Αποτυχία ενημέρωσης εκδήλωσης.',
      eventIdMissing: 'Το API εκδηλώσεων δεν επέστρεψε id εκδήλωσης.',
      addGuests: 'Αποτυχία προσθήκης επιλεγμένων ατόμων ως καλεσμένων.',
      sendInvitations: 'Αποτυχία αποστολής προσκλήσεων.',
      completeWizard: 'Αποτυχία ολοκλήρωσης οδηγού.'
    },
    success: {
      sent: 'Οι προσκλήσεις στάλθηκαν επιτυχώς.',
      scheduled: 'Η εκδήλωση είναι σε readyToSend. Οι προσκλήσεις προγραμματίστηκαν για {{sendAt}}.',
      queuedScheduled: 'Ευχαριστούμε. Το μήνυμά σας μπήκε σε ουρά και θα σταλεί στις {{sendAt}}.',
      queuedImmediately: 'Ευχαριστούμε. Το μήνυμά σας μπήκε σε ουρά και θα σταλεί άμεσα.'
    }
  },
  publicInvitation: {
    title: 'Πρόσκληση',
    loading: 'Φόρτωση πρόσκλησης...',
    welcome: 'Γεια σου {{guestName}}',
    eventTitle: 'Εκδήλωση',
    occasion: 'Περίσταση',
    scheduled: 'Ημερομηνία και ώρα',
    venue: 'Χώρος',
    address: 'Διεύθυνση',
    currentResponse: 'Τρέχουσα απάντηση',
    answerPrompt: 'Παρακαλώ επίλεξε την απάντησή σου',
    responseSaved: 'Η απάντησή σου αποθηκεύτηκε.',
    viewWishlist: 'Δες τη λίστα επιθυμιών δώρων',
    actions: {
      agree: 'Συμφωνώ',
      dontKnow: 'Δεν ξέρω',
      reject: 'Απόρριψη'
    },
    countPersonDialog: {
      title: 'Πόσα άτομα;',
      description: 'Παρακαλώ εισάγετε τον συνολικό αριθμό ατόμων που θα παρευρεθούν (συμπεριλαμβανομένου εσάς).',
      confirm: 'Επιβεβαίωση',
      cancel: 'Ακύρωση'
    },
    errors: {
      backendUnavailable:
        'Αδυναμία πρόσβασης στο backend API στο {{baseUrl}}. Ξεκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      invalidInvitation: 'Αυτός ο σύνδεσμος πρόσκλησης δεν είναι έγκυρος ή έχει λήξει.',
      loadInvitation: 'Αδυναμία φόρτωσης της πρόσκλησης αυτή τη στιγμή.',
      submitRsvp: 'Αδυναμία αποστολής της απάντησής σου αυτή τη στιγμή.'
    }
  },
  auth: {
    login: {
      title: 'Σύνδεση',
      noAccount: 'Δεν έχετε λογαριασμό;',
      emailLabel: 'Διεύθυνση email',
      emailPlaceholder: 'Εισάγετε email',
      passwordLabel: 'Κωδικός',
      passwordPlaceholder: 'Εισάγετε κωδικό',
      keepSignedIn: 'Παραμονή συνδεδεμένου',
      forgotPassword: 'Ξεχάσατε τον κωδικό;',
      button: 'Σύνδεση',
      invalidCredentials: 'Μη έγκυρο email ή κωδικός.',
      unableToLogin: 'Αδυναμία σύνδεσης αυτή τη στιγμή. Δοκιμάστε ξανά.'
    },
    forgotPassword: {
      title: 'Ξέχασα τον κωδικό',
      backToLogin: 'Επιστροφή στη σύνδεση',
      emailLabel: 'Διεύθυνση email',
      emailPlaceholder: 'Εισάγετε email',
      button: 'Αποστολή συνδέσμου επαναφοράς',
      success: 'Αν υπάρχει το email, στάλθηκε σύνδεσμος επαναφοράς.',
      error: 'Αδυναμία αποστολής συνδέσμου τώρα. Δοκιμάστε ξανά.'
    },
    resetPassword: {
      title: 'Επαναφορά κωδικού',
      backToLogin: 'Επιστροφή στη σύνδεση',
      passwordLabel: 'Νέος κωδικός',
      passwordPlaceholder: 'Εισάγετε νέο κωδικό',
      confirmPasswordLabel: 'Επιβεβαίωση κωδικού',
      confirmPasswordPlaceholder: 'Επαναλάβετε τον νέο κωδικό',
      button: 'Επαναφορά κωδικού',
      success: 'Ο κωδικός σας επαναφέρθηκε επιτυχώς. Μπορείτε να συνδεθείτε.',
      error: 'Αδυναμία επαναφοράς κωδικού. Ο σύνδεσμος ενδέχεται να έχει λήξει.',
      invalidToken: 'Μη έγκυρο ή ελλιπές token. Ζητήστε νέο σύνδεσμο επαναφοράς.',
      confirmPasswordRequired: 'Παρακαλώ επιβεβαιώστε τον κωδικό σας',
      passwordsMustMatch: 'Οι κωδικοί πρέπει να ταιριάζουν'
    },
    confirmEmail: {
      title: 'Επιβεβαιώστε τη διεύθυνση email σας',
      backToLogin: 'Επιστροφή στη σύνδεση',
      instructions: 'Πατήστε το κουμπί για να επιβεβαιώσετε τη διεύθυνση email σας.',
      button: 'Επιβεβαίωση email',
      successTitle: 'Ευχαριστούμε!',
      successMessage: 'Η διεύθυνση email σας επιβεβαιώθηκε. Τώρα μπορείτε να συνδεθείτε.',
      checkInboxTitle: 'Ελέγξτε τα εισερχόμενα',
      checkInboxMessage: 'Στείλαμε σύνδεσμο επιβεβαίωσης. Ανοίξτε τον για να επαληθεύσετε το email σας.',
      checkInboxEmail: 'Το email επιβεβαίωσης στάλθηκε στο: {{email}}',
      error: 'Αδυναμία επιβεβαίωσης email τώρα. Ο σύνδεσμος μπορεί να είναι άκυρος ή να έχει λήξει.'
    },
    register: {
      title: 'Εγγραφή',
      haveAccount: 'Έχετε ήδη λογαριασμό;',
      firstNameLabel: 'Όνομα*',
      lastNameLabel: 'Επώνυμο*',
      phoneLabel: 'Τηλέφωνο',
      emailLabel: 'Διεύθυνση email*',
      passwordLabel: 'Κωδικός',
      confirmPasswordLabel: 'Επιβεβαίωση κωδικού',
      firstNamePlaceholder: 'Γιώργος',
      lastNamePlaceholder: 'Παπαδόπουλος',
      countryCodePlaceholder: '+30',
      phonePlaceholder: '6912345678',
      emailPlaceholder: 'demo@etaireia.gr',
      agreeText: 'Με την εγγραφή σας αποδέχεστε τους',
      termsOfService: 'Όρους χρήσης',
      privacyPolicy: 'Πολιτική απορρήτου',
      button: 'Δημιουργία λογαριασμού',
      unableToRegister: 'Αδυναμία δημιουργίας λογαριασμού αυτή τη στιγμή. Προσπαθήστε ξανά.',
      emailAlreadyExists: 'Υπάρχει ήδη λογαριασμός με αυτό το email. Παρακαλώ συνδεθείτε.',
      goToLogin: 'Μετάβαση στη Σύνδεση',
      successToast: 'Ο λογαριασμός δημιουργήθηκε. Ελέγξτε το email σας για επιβεβαίωση.',
      welcome: {
        defaultName: 'φίλε',
        title: 'Καλώς ήρθες, {{firstName}}',
        instructions: {
          line1: 'Ο λογαριασμός σου είναι έτοιμος και μπορείς να ξεκινήσεις τη διοργάνωση εκδηλώσεων.',
          line2: 'Χρησιμοποίησε τον πίνακα για δημιουργία εκδηλώσεων, διαχείριση καλεσμένων και παρακολούθηση απαντήσεων.',
          line3: 'Αν είναι η πρώτη σου επίσκεψη, ξεκίνα από την αρχική εικόνα του πίνακα.'
        },
        goToDashboard: 'Μετάβαση Στον Πίνακα Διαχείρισης'
      }
    },
    validation: {
      mustBeValidEmail: 'Πρέπει να είναι έγκυρο email',
      emailRequired: 'Το email είναι υποχρεωτικό',
      passwordRequired: 'Ο κωδικός είναι υποχρεωτικός',
      passwordNoSpaces: 'Ο κωδικός δεν μπορεί να αρχίζει ή να τελειώνει με κενά',
      passwordTooLongLogin: 'Ο κωδικός πρέπει να έχει λιγότερους από 100 χαρακτήρες',
      passwordTooLongRegister: 'Ο κωδικός πρέπει να έχει λιγότερους από 10 χαρακτήρες',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      lastNameRequired: 'Το επώνυμο είναι υποχρεωτικό',
      confirmPasswordRequired: 'Παρακαλώ επιβεβαιώστε τον κωδικό σας',
      passwordsMustMatch: 'Οι κωδικοί πρέπει να ταιριάζουν'
    }
  },
  profile: {
    title: 'Προφίλ',
    aria: {
      openProfile: 'άνοιγμα προφίλ',
      profileUserAlt: 'χρήστης προφίλ',
      profileTabs: 'καρτέλες προφίλ'
    },
    defaults: {
      adminUser: 'Χρήστης διαχειριστής',
      administrator: 'Διαχειριστής'
    },
    tabs: {
      profile: 'Προφίλ',
      setting: 'Ρυθμίσεις'
    },
    menu: {
      editProfile: 'Επεξεργασία προφίλ',
      viewProfile: 'Προβολή προφίλ',
      socialProfile: 'Κοινωνικό προφίλ',
      billing: 'Χρέωση',
      billingHistory: 'Ιστορικό χρεώσεων',
      renewSubscription: 'Ανανέωση συνδρομής',
      logout: 'Αποσύνδεση'
    },
    settingMenu: {
      support: 'Υποστήριξη',
      accountSettings: 'Ρυθμίσεις λογαριασμού',
      privacyCenter: 'Κέντρο απορρήτου',
      feedback: 'Σχόλια',
      history: 'Ιστορικό'
    },
    fields: {
      email: 'Email',
      role: 'Ρόλος',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      fullName: 'Πλήρες όνομα',
      birthday: 'Ημερομηνία γέννησης',
      invoiceEnabled: 'Χρειάζομαι στοιχεία τιμολόγησης',
      invoiceCompanyName: 'Εταιρεία / Όνομα τιμολογίου',
      invoiceVatNumber: 'ΑΦΜ',
      invoiceAddressLine1: 'Διεύθυνση γραμμή 1',
      invoiceAddressLine2: 'Διεύθυνση γραμμή 2',
      invoiceCity: 'Πόλη',
      invoicePostalCode: 'Ταχυδρομικός κώδικας',
      invoiceCountry: 'Χώρα'
    },
    edit: {
      title: 'Επεξεργασία προφίλ',
      subtitle: 'Ενημερώστε τα προσωπικά σας στοιχεία και τα προαιρετικά στοιχεία τιμολόγησης.',
      successSaved: 'Το προφίλ αποθηκεύτηκε επιτυχώς.',
      currentDisplayName: 'Τρέχον όνομα εμφάνισης: {{name}}',
      actions: {
        save: 'Αποθήκευση προφίλ',
        reset: 'Επαναφορά',
        viewProfile: 'Προβολή προφίλ',
        backToDashboard: 'Επιστροφή στο dashboard'
      }
    },
    view: {
      title: 'Προβολή προφίλ',
      accountLoadError: 'Αδυναμία φόρτωσης στοιχείων λογαριασμού από τον διακομιστή.',
      invoiceNotEnabled: 'Τα στοιχεία τιμολόγησης δεν είναι ενεργοποιημένα.',
      sections: {
        account: 'Λογαριασμός',
        personalInformation: 'Προσωπικά στοιχεία',
        invoiceDetails: 'Στοιχεία τιμολόγησης'
      },
      actions: {
        editProfile: 'Επεξεργασία προφίλ',
        backToDashboard: 'Επιστροφή στο dashboard',
        refreshLocalData: 'Ανανέωση τοπικών δεδομένων'
      },
      deleteAccount: {
        button: 'Διαγραφή Λογαριασμού',
        dialogTitle: 'Διαγραφή του λογαριασμού σας;',
        warning: 'Αυτό θα διαγράψει οριστικά τον λογαριασμό σας, τις εκδηλώσεις και όλα τα σχετικά δεδομένα. Δεν μπορεί να αναιρεθεί.',
        sendCode: 'Αποστολή κωδικού διαγραφής',
        codePrompt: 'Εισαγάγετε τον 6ψήφιο κωδικό που στάλθηκε στο email σας',
        codePlaceholder: '000000',
        confirmDeletion: 'Επιβεβαίωση Διαγραφής',
        resendCode: 'Επαναποστολή κωδικού',
        resendCooldown: 'Επαναποστολή σε {{seconds}}δ',
        cancel: 'Ακύρωση'
      }
    }
  },
  billingHistoryPage: {
    title: 'Ιστορικό χρεώσεων',
    subtitle: 'Δείτε την κατάσταση χρέωσης και την πρόσφατη δραστηριότητα πληρωμών.',
    loading: 'Φόρτωση δεδομένων χρέωσης...',
    comingSoon: 'Αναλυτικό ιστορικό χρεώσεων σύντομα',
    note: 'Μπορείτε να ανανεώσετε τη συνδρομή τώρα και οι αναλυτικές γραμμές τιμολόγησης θα εμφανιστούν εδώ μόλις γίνει διαθέσιμο το endpoint ιστορικού.',
    yes: 'Ναι',
    no: 'Όχι',
    summary: {
      premiumAccess: 'Πρόσβαση premium',
      premiumUntil: 'Premium έως',
      smsCredits: 'Πιστώσεις SMS',
      maxGuests: 'Μέγιστοι καλεσμένοι / εκδήλωση',
      smsEnabled: 'SMS ενεργό'
    },
    actions: {
      renewSubscription: 'Ανανέωση συνδρομής',
      backToDashboard: 'Επιστροφή στο dashboard'
    },
    errors: {
      load: 'Αδυναμία φόρτωσης κατάστασης χρέωσης αυτή τη στιγμή.'
    }
  },
  adminTransactionsPage: {
    title: 'Όλες οι συναλλαγές',
    subtitle: 'Οι διαχειριστές μπορούν να δουν συναλλαγές χρέωσης για όλους τους χρήστες.',
    loading: 'Φόρτωση συναλλαγών...',
    empty: 'Δεν υπάρχουν συναλλαγές ακόμη.',
    noMatches: 'Δεν υπάρχουν συναλλαγές που να ταιριάζουν με τα φίλτρα.',
    filters: {
      status: 'Κατάσταση',
      allStatuses: 'Όλες οι καταστάσεις',
      userEmail: 'Email χρήστη',
      userEmailPlaceholder: 'Αναζήτηση με email',
      createdFrom: 'Δημιουργία από',
      createdTo: 'Δημιουργία έως',
      sort: 'Ταξινόμηση',
      pageSize: 'Μέγεθος σελίδας',
      clear: 'Καθαρισμός',
      results: 'Εμφανίζονται {{shown}} από {{total}} συναλλαγές'
    },
    sort: {
      createdDesc: 'Πιο πρόσφατες πρώτα',
      createdAsc: 'Πιο παλιές πρώτα',
      toggleToNewest: 'Ταξινόμηση με πιο πρόσφατες πρώτα',
      toggleToOldest: 'Ταξινόμηση με πιο παλιές πρώτα'
    },
    pagination: {
      previous: 'Προηγούμενη',
      next: 'Επόμενη',
      pageOf: 'Σελίδα {{page}} από {{totalPages}}'
    },
    status: {
      pending: 'Σε εκκρεμότητα',
      completed: 'Ολοκληρωμένη',
      failed: 'Αποτυχημένη'
    },
    table: {
      created: 'Δημιουργία',
      user: 'Χρήστης',
      plan: 'Πλάνο',
      amount: 'Ποσό',
      status: 'Κατάσταση',
      completed: 'Ολοκλήρωση',
      externalPaymentId: 'External Payment ID',
      transactionId: 'Transaction ID'
    },
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η πρόσβαση στο API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      load: 'Αδυναμία φόρτωσης συναλλαγών αυτή τη στιγμή.'
    }
  },
  notificationsPage: {
    title: 'Όλες οι ειδοποιήσεις',
    description: 'Αυτή η σελίδα χρησιμοποιεί το ίδιο πρότυπο ειδοποιήσεων με το αναδυόμενο του header, ώστε να μπορούν να προστεθούν περισσότεροι τύποι στο μέλλον.',
    unreadCount: '{{count}} μη αναγνωσμένες',
    noMatches: 'Δεν υπάρχουν ειδοποιήσεις που να ταιριάζουν με αυτό το φίλτρο.',
    filters: {
      all: 'Όλα',
      unread: 'Μη αναγνωσμένες',
      rsvp: 'RSVP',
      billing: 'Χρέωση',
      invitations: 'Προσκλήσεις',
      newUsers: 'Νέοι χρήστες',
      newEvents: 'Νέες εκδηλώσεις'
    },
    actions: {
      markAllRead: 'Σήμανση όλων ως αναγνωσμένων',
      delete: 'Διαγραφή',
      cancel: 'Ακύρωση'
    },
    deleteOptions: {
      deleteAll: 'Διαγραφή όλων',
      deleteOlder1Month: 'Διαγραφή παλιότερων του 1 μήνα',
      deleteOlder3Months: 'Διαγραφή παλιότερων των 3 μηνών',
      deleteOlder6Months: 'Διαγραφή παλιότερων των 6 μηνών'
    },
    deleteDialog: {
      title: 'Επιβεβαίωση ενέργειας διαγραφής',
      message: 'Θα εφαρμοστεί: {{action}}. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
      confirm: 'Επιβεβαίωση: {{action}}'
    }
  },
  emailTemplates: {
    title: 'Πρότυπα email',
    newTemplate: 'Νέο πρότυπο',
    adminOnly: 'Αυτή η σελίδα είναι διαθέσιμη μόνο σε διαχειριστές.',
    sendTestEmail: 'Αποστολή δοκιμαστικού email',
    filterByType: 'Φιλτράρισμα ανά τύπο',
    filterByLanguage: 'Φιλτράρισμα ανά γλώσσα',
    all: 'Όλα',
    search: 'Αναζήτηση',
    searchPlaceholder: 'Τύπος, θέμα, κείμενο',
    loading: 'Φόρτωση προτύπων...',
    noTemplates: 'Δεν υπάρχουν πρότυπα που να ταιριάζουν με τα τρέχοντα φίλτρα.',
    edit: 'Επεξεργασία',
    table: {
      action: 'Ενέργεια',
      type: 'Τύπος',
      language: 'Γλώσσα',
      subject: 'Θέμα'
    },
    dialog: {
      saveTitle: 'Αποθήκευση προτύπου email',
      testTitle: 'Αποστολή δοκιμαστικού email',
      typeLabel: 'Τύπος',
      languageLabel: 'Γλώσσα',
      languageHelper: 'Επιλέξτε γλώσσα προτύπου',
      subjectLabel: 'Θέμα',
      bodyLabel: 'Κείμενο (HTML)',
      bodyHelper: 'Υποστηριζόμενοι δείκτες θέσης: {{Email}}, {{Token}}, {{ConfirmationLink}}, {{ResetLink}}, {{EventTitle}}, {{EventDate}}, {{EventLink}}',
      livePreview: 'Ζωντανή προεπισκόπηση',
      previewCaption: 'Η προεπισκόπηση χρησιμοποιεί δείγματα τιμών για επαλήθευση των δεικτών πριν την αποθήκευση.',
      toEmailLabel: 'Προς (email)',
      templateTypeLabel: 'Τύπος προτύπου',
      testLanguageHelper: 'Επιλέξτε την έκδοση γλώσσας του προτύπου για αποστολή',
      cancel: 'Ακύρωση',
      save: 'Αποθήκευση',
      send: 'Αποστολή'
    },
    success: {
      saved: 'Το πρότυπο email αποθηκεύτηκε με επιτυχία.',
      testSent: 'Το δοκιμαστικό email στάλθηκε στο {{toEmail}}.'
    },
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η πρόσβαση στο API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      load: 'Αποτυχία φόρτωσης προτύπων email.',
      save: 'Αποτυχία αποθήκευσης προτύπου email.',
      sendTest: 'Αποτυχία αποστολής δοκιμαστικού email.',
      subjectBodyRequired: 'Το θέμα και το κείμενο είναι υποχρεωτικά.',
      recipientRequired: 'Το email παραλήπτη είναι υποχρεωτικό.',
      invalidEmail: 'Παρακαλώ εισάγετε έγκυρη διεύθυνση email.'
    }
  },
  eventTemplates: {
    title: 'Πρότυπα εκδηλώσεων',
    newTemplate: 'Νέο πρότυπο',
    adminOnly: 'Αυτή η σελίδα είναι διαθέσιμη μόνο σε διαχειριστές.',
    filterByLanguage: 'Φιλτράρισμα ανά γλώσσα',
    all: 'Όλα',
    search: 'Αναζήτηση',
    searchPlaceholder: 'Τύπος, όνομα, κείμενο',
    loading: 'Φόρτωση προτύπων...',
    noTemplates: 'Δεν υπάρχουν πρότυπα που να ταιριάζουν με τα τρέχοντα φίλτρα.',
    edit: 'Επεξεργασία',
    translate: 'Μετάφραση',
    preview: 'Προεπισκόπηση',
    previewDialog: {
      title: 'Προεπισκόπηση προτύπου',
      close: 'Κλείσιμο'
    },
    table: {
      action: 'Ενέργεια',
      name: 'Όνομα',
      type: 'Τύπος',
      language: 'Γλώσσα',
      translations: 'Μεταφράσεις',
      completeness: 'Πληρότητα',
      complete: 'Πλήρες',
      incomplete: 'Ελλιπές',
      preview: 'Προεπισκόπηση',
      created: 'Δημιουργήθηκε'
    },
    translateDialog: {
      title: 'Μετάφραση προτύπου',
      sourceTemplate: 'Πρότυπο πηγής',
      targetLanguage: 'Γλώσσα στόχος',
      noLanguagesAvailable: 'Όλες οι γλώσσες έχουν μετάφραση για αυτό το πρότυπο.',
      save: 'Αποθήκευση μετάφρασης',
      cancel: 'Ακύρωση'
    },
    dialog: {
      saveTitle: 'Αποθήκευση προτύπου εκδήλωσης',
      typeLabel: 'Τύπος εκδήλωσης',
      nameLabel: 'Όνομα',
      languageLabel: 'Γλώσσα',
      emailBodyLabel: 'Κείμενο email (HTML)',
      invitationBodyLabel: 'Κείμενο δημόσιας πρόσκλησης (HTML)',
      invitationBodyHelper:
        'Χρησιμοποιείται στη δημόσια σελίδα πρόσκλησης (/i/{code}) με ενέργειες RSVP. Υποστηριζόμενοι δείκτες θέσης: {{GuestName}}, {{EventTitle}}, {{EventDateUtc}}, {{Venue}}, {{Address}}, {{InvitationLink}}, {{ScanCode}}, {{TableNumber}}',
      bodyHelper: 'Υποστηριζόμενοι δείκτες θέσης: {{GuestName}}, {{EventTitle}}, {{EventDateUtc}}, {{Venue}}, {{Address}}, {{InvitationLink}}, {{ScanCode}}, {{TableNumber}}',
      smsBodyLabel: 'Κείμενο SMS (απλό κείμενο)',
      smsBodyHelper: 'Προαιρετική έκδοση SMS με μικρό όριο ({{current}}/{{max}}). Υποστηρίζονται δείκτες θέσης.',
      livePreview: 'Ζωντανή προεπισκόπηση',
      emailPreviewTitle: 'Προεπισκόπηση email',
      invitationPreviewTitle: 'Προεπισκόπηση δημόσιας πρόσκλησης',
      smsPreviewTitle: 'Προεπισκόπηση SMS',
      emptyPreview: 'Δεν υπάρχει ακόμα περιεχόμενο.',
      previewCaption: 'Η προεπισκόπηση χρησιμοποιεί δείγματα τιμών για επαλήθευση των δεικτών πριν την αποθήκευση.',
      cancel: 'Ακύρωση',
      save: 'Αποθήκευση'
    },
    typeOptions: {
      other: 'Άλλο',
      wedding: 'Γάμος',
      birthday: 'Γενέθλια',
      conference: 'Συνέδριο',
      meeting: 'Συνάντηση',
      party: 'Πάρτι'
    },
    success: {
      saved: 'Το πρότυπο εκδήλωσης αποθηκεύτηκε με επιτυχία.',
      translated: 'Η μετάφραση αποθηκεύτηκε με επιτυχία.'
    },
    errorDialog: {
      title: 'Σφάλμα',
      close: 'Κλείσιμο'
    },
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η πρόσβαση στο API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      load: 'Αποτυχία φόρτωσης προτύπων εκδήλωσης.',
      save: 'Αποτυχία αποθήκευσης προτύπου εκδήλωσης.',
      translate: 'Αποτυχία αποθήκευσης μετάφρασης.',
      nameBodyRequired: 'Το όνομα και το κείμενο είναι υποχρεωτικά.',
      nameEmailInvitationRequired: 'Το όνομα, το κείμενο email και το κείμενο πρόσκλησης είναι υποχρεωτικά.',
      smsBodyTooLong: 'Το κείμενο SMS δεν μπορεί να ξεπερνά τους {{max}} χαρακτήρες.'
    }
  },
  usersPage: {
    title: 'Χρήστες',
    createUser: 'Δημιουργία χρήστη',
    adminOnly: 'Αυτή η σελίδα είναι διαθέσιμη μόνο σε διαχειριστές.',
    loading: 'Φόρτωση χρηστών...',
    noUsers: 'Δεν βρέθηκαν χρήστες.',
    view: 'Προβολή',
    edit: 'Επεξεργασία',
    yes: 'Ναι',
    no: 'Όχι',
    table: {
      action: 'Ενέργεια',
      email: 'Email',
      role: 'Ρόλος',
      language: 'Γλώσσα',
      timeZone: 'Ζώνη ώρας',
      emailConfirmed: 'Email επιβεβαιωμένο',
      created: 'Δημιουργήθηκε',
      lastLogin: 'Τελευταία σύνδεση'
    },
    createDialog: {
      title: 'Δημιουργία χρήστη',
      emailLabel: 'Email',
      passwordLabel: 'Κωδικός',
      roleLabel: 'Ρόλος',
      preferredLanguageLabel: 'Προτιμώμενη γλώσσα',
      timeZoneLabel: 'Ζώνη ώρας',
      cancel: 'Ακύρωση',
      create: 'Δημιουργία'
    },
    editDialog: {
      title: 'Επεξεργασία χρήστη',
      emailLabel: 'Email',
      roleLabel: 'Ρόλος',
      preferredLanguageLabel: 'Προτιμώμενη γλώσσα',
      timeZoneLabel: 'Ζώνη ώρας',
      emailConfirmedLabel: 'Email επιβεβαιωμένο',
      cancel: 'Ακύρωση',
      save: 'Αποθήκευση'
    },
    viewDialog: {
      title: 'Στοιχεία χρήστη',
      email: 'Email',
      role: 'Ρόλος',
      preferredLanguage: 'Προτιμώμενη γλώσσα',
      timeZone: 'Ζώνη ώρας',
      emailConfirmed: 'Email επιβεβαιωμένο',
      created: 'Δημιουργήθηκε',
      lastLogin: 'Τελευταία σύνδεση',
      userId: 'ID χρήστη',
      loadingDetails: 'Φόρτωση στοιχείων χρήστη...',
      close: 'Κλείσιμο'
    },
    success: {
      created: 'Ο χρήστης δημιουργήθηκε με επιτυχία.',
      updated: 'Ο χρήστης ενημερώθηκε με επιτυχία.'
    },
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η πρόσβαση στο API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      load: 'Αποτυχία φόρτωσης χρηστών.',
      create: 'Αποτυχία δημιουργίας χρήστη.',
      update: 'Αποτυχία ενημέρωσης χρήστη.',
      loadDetails: 'Αποτυχία φόρτωσης στοιχείων χρήστη.',
      emailPasswordRequired: 'Το email και ο κωδικός είναι υποχρεωτικά.',
      emailRequired: 'Το email είναι υποχρεωτικό.',
      invalidEmail: 'Παρακαλώ εισάγετε έγκυρη διεύθυνση email.'
    }
  },
  scheduledPage: {
    title: 'Ουρά',
    adminOnly: 'Αυτή η σελίδα είναι διαθέσιμη μόνο για διαχειριστές.',
    refresh: 'Ανανέωση',
    loading: 'Φόρτωση προγραμματισμών...',
    noSchedules: 'Δεν βρέθηκαν στοιχεία στην ουρά.',
    allModesHint: 'Αυτή η σελίδα περιλαμβάνει άμεσες και προγραμματισμένες εκδηλώσεις με ζωντανή κατάσταση ουράς και αποστολής.',
    nextSchedulerRun: 'Επόμενη εκτέλεση scheduler',
    everyMinutes: 'κάθε {{count}} λεπτό(ά)',
    summary: {
      total: 'Σύνολο',
      completed: 'Ολοκληρωμένα',
      notCompleted: 'Μη ολοκληρωμένα',
      overdue: 'Καθυστερημένα',
      queuedNow: 'Στην ουρά τώρα',
      scheduledMode: 'Προγραμματισμένη λειτουργία',
      immediateMode: 'Άμεση λειτουργία',
      sending: 'Σε αποστολή'
    },
    status: {
      completed: 'Ολοκληρωμένο',
      notCompleted: 'Μη ολοκληρωμένο',
      overdue: 'Καθυστερημένο'
    },
    queueState: {
      queued: 'Στην ουρά',
      idle: 'Αδρανές'
    },
    sendDateMode: {
      scheduled: 'Προγραμματισμένη',
      immediately: 'Άμεση'
    },
    retry: {
      action: 'Επανάληψη τώρα',
      running: 'Επανάληψη...',
      success: 'Η επανάληψη μπήκε στην ουρά για "{{title}}".',
      failed: 'Αποτυχία επανάληψης για αυτή την εκδήλωση.',
      disabled: {
        completed: 'Αυτή η εκδήλωση έχει ήδη ολοκληρωθεί.',
        sending: 'Η αποστολή για αυτή την εκδήλωση είναι ήδη σε εξέλιξη.',
        eventPassed: 'Η επανάληψη τώρα είναι διαθέσιμη μόνο πριν περάσει η ημερομηνία/ώρα της εκδήλωσης.'
      }
    },
    filter: {
      label: 'Φίλτρο',
      options: {
        all: 'Όλα',
        completed: 'Ολοκληρωμένα',
        notCompleted: 'Μη ολοκληρωμένα',
        overdue: 'Καθυστερημένα',
        queuedNow: 'Στην ουρά τώρα',
        sending: 'Σε αποστολή'
      }
    },
    providerFilter: {
      label: 'Φίλτρο ανά μέθοδο αποστολής',
      all: 'Όλες οι μέθοδοι αποστολής'
    },
    sort: {
      label: 'Ταξινόμηση',
      options: {
        nextRunAsc: 'Επόμενη εκτέλεση (νωρίτερα πρώτα)',
        nextRunDesc: 'Επόμενη εκτέλεση (αργότερα πρώτα)',
        scheduledAsc: 'Προγραμματισμένο για (νωρίτερα πρώτα)',
        scheduledDesc: 'Προγραμματισμένο για (αργότερα πρώτα)',
        lastSentDesc: 'Τελευταία αποστολή (νεότερα πρώτα)',
        lastAttemptDesc: 'Τελευταία προσπάθεια (νεότερα πρώτα)',
        createdDesc: 'Δημιουργήθηκε (νεότερα πρώτα)',
        createdAsc: 'Δημιουργήθηκε (παλαιότερα πρώτα)'
      }
    },
    table: {
      eventTitle: 'Εκδήλωση',
      completed: 'Ολοκλήρωση',
      status: 'Κατάσταση',
      queueState: 'Ουρά',
      sendDateMode: 'Λειτουργία αποστολής',
      sendProviders: 'Μέθοδοι αποστολής',
      scheduledAt: 'Προγραμματισμένο για',
      nextRun: 'Επόμενη εκτέλεση',
      lastAttemptAt: 'Τελευταία προσπάθεια',
      lastSentAt: 'Τελευταία αποστολή',
      deliveryCounts: 'Μετρήσεις αποστολής',
      deliveryCountsValue: 'Απεσταλμένα: {{sent}} | Αποτυχημένα: {{failed}} | Εκκρεμή: {{pending}}',
      createdAt: 'Δημιουργήθηκε',
      actions: 'Ενέργειες'
    },
    errors: {
      backendUnavailable: 'Αδυναμία πρόσβασης στο API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      load: 'Αποτυχία φόρτωσης προγραμματισμένων στοιχείων.'
    }
  },
  peoplePage: {
    title: 'Άτομα',
    importAvailability: 'Εισαγωγή διαθεσιμότητας (Excel)',
    createPerson: 'Δημιουργία ατόμου',
    active: 'Ενεργά',
    archived: 'Αρχειοθετημένα',
    searchLabel: 'Αναζήτηση',
    searchPlaceholder: 'Αναζήτηση με όνομα, email ή τηλέφωνο',
    pageSize: 'Μέγεθος σελίδας',
    results: 'Εμφάνιση {{shown}} από {{total}} άτομα',
    noMatches: 'Δεν βρέθηκαν άτομα για την αναζήτησή σας.',
    loading: 'Φόρτωση {{view}} ατόμων...',
    noArchivedPeople: 'Δεν υπάρχουν αρχειοθετημένα άτομα ακόμα.',
    noPeople: 'Δεν υπάρχουν άτομα ακόμα. Δημιουργήστε ένα άτομο ή εισάγετε διαθεσιμότητα από αρχείο Excel.',
    edit: 'Επεξεργασία',
    archive: 'Αρχειοθέτηση',
    restore: 'Επαναφορά',
    table: {
      action: 'Ενέργεια',
      fullName: 'Πλήρες όνομα',
      email: 'Email',
      phone: 'Τηλέφωνο',
      availability: 'Διαθεσιμότητα',
      countPerson: 'Αριθμός ατόμων',
      archivedAt: 'Αρχειοθετήθηκε'
    },
    dialog: {
      createTitle: 'Δημιουργία ατόμου',
      editTitle: 'Επεξεργασία ατόμου',
      fullNameLabel: 'Πλήρες όνομα',
      emailLabel: 'Email',
      phoneLabel: 'Τηλέφωνο',
      availabilityLabel: 'Διαθεσιμότητα',
      countPersonLabel: 'Αριθμός ατόμων',
      availabilityPlaceholder: 'Παράδειγμα: Δευ-Παρ 09:00-18:00',
      cancel: 'Ακύρωση',
      save: 'Αποθήκευση',
      create: 'Δημιουργία'
    },
    confirmArchive: 'Αρχειοθέτηση {{name}};',
    confirmRestore: 'Επαναφορά {{name}};',
    success: {
      archived: 'Το άτομο αρχειοθετήθηκε με επιτυχία.',
      restored: 'Το άτομο επαναφέρθηκε με επιτυχία.',
      created: 'Το άτομο δημιουργήθηκε με επιτυχία.',
      updated: 'Το άτομο ενημερώθηκε με επιτυχία.',
      importComplete: 'Η εισαγωγή Excel ολοκληρώθηκε. Προστέθηκαν {{added}}, ενημερώθηκαν {{updated}}.'
    },
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η πρόσβαση στο API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      load: 'Αδύνατη η φόρτωση ατόμων αυτή τη στιγμή.',
      loadArchived: 'Αδύνατη η φόρτωση αρχειοθετημένων ατόμων αυτή τη στιγμή.',
      archive: 'Αποτυχία αρχειοθέτησης ατόμου.',
      restore: 'Αποτυχία επαναφοράς ατόμου.',
      create: 'Αποτυχία δημιουργίας ατόμου.',
      update: 'Αποτυχία ενημέρωσης ατόμου.',
      importFailed: 'Αδύνατη η εισαγωγή αυτού του αρχείου. Ανεβάστε έγκυρο αρχείο .xlsx ή .xls.',
      importApiError: 'Αποτυχία εισαγωγής ατόμων από Excel.',
      emptyFile: 'Το επιλεγμένο αρχείο Excel είναι κενό.',
      fullNameEmailRequired: 'Το πλήρες όνομα και το email είναι υποχρεωτικά.',
      invalidEmail: 'Παρακαλώ εισάγετε έγκυρη διεύθυνση email.'
    },
    freeLimit: {
      reached: 'Έχετε φτάσει στο όριο των 50 ατόμων για το δωρεάν πλάνο. Αναβαθμίστε σε Premium για απεριόριστη πρόσβαση.',
      upgradeButton: 'Αναβάθμιση σε Premium'
    },
    pagination: {
      previous: 'Προηγούμενη',
      next: 'Επόμενη',
      goToPage: 'Μετάβαση σε σελίδα',
      pageOf: 'Σελίδα {{page}} από {{totalPages}}'
    }
  },
  financePage: {
    title: 'Οικονομικά',
    financeButton: 'Οικονομικά',
    premiumRequired: 'Τα Οικονομικά Εκδηλώσεων είναι λειτουργία Premium',
    premiumDescription: 'Παρακολουθήστε έσοδα, έξοδα και κέρδη/ζημίες των εκδηλώσεών σας. Συνδέστε δώρα με καλεσμένους, συγκρίνετε προγραμματισμένα με πραγματικά και δείτε οικονομικές συνοπτικές αναφορές — όλα σε ένα μέρος.',
    upgradeNow: 'Αναβάθμιση τώρα',
    total: 'Σύνολο',
    entries: 'εγγραφές',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    confirmDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την εγγραφή;',
    tabs: { budget: 'Προϋπολογισμός', income: 'Έσοδα', expenses: 'Έξοδα', summary: 'Σύνοψη' },
    budget: {
      title: 'Προϋπολογισμός Εκδήλωσης',
      plannedIncome: 'Προγραμματισμένα Έσοδα',
      plannedExpenses: 'Προγραμματισμένα Έξοδα',
      expectedGuests: 'Αναμενόμενοι Καλεσμένοι',
      expectedAttendees: 'Αναμενόμενοι Παρευρισκόμενοι',
      notes: 'Σημειώσεις',
      save: 'Αποθήκευση Προϋπολογισμού',
      saved: 'Ο προϋπολογισμός αποθηκεύτηκε επιτυχώς',
      plannedProfit: 'Προγραμματισμένο Κέρδος'
    },
    income: {
      title: 'Έσοδα', addIncome: 'Προσθήκη Εσόδου', editIncome: 'Επεξεργασία Εσόδου', noEntries: 'Δεν υπάρχουν εγγραφές εσόδων ακόμα.',
      category: 'Κατηγορία', amount: 'Ποσό', description: 'Περιγραφή', guest: 'Καλεσμένος',
      receivedAt: 'Ημερομηνία Λήψης', anonymous: 'Ανώνυμο Δώρο', groupGift: 'Ομαδικό Δώρο', groupSize: 'Αριθμός Συνεισφερόντων',
      categories: { Gift: 'Δώρο', TicketSale: 'Πώληση Εισιτηρίων', Sponsorship: 'Χορηγία', Donation: 'Δωρεά', Other: 'Άλλο' }
    },
    expenses: {
      title: 'Έξοδα', addExpense: 'Προσθήκη Εξόδου', editExpense: 'Επεξεργασία Εξόδου', noEntries: 'Δεν υπάρχουν εγγραφές εξόδων ακόμα.',
      category: 'Κατηγορία', vendor: 'Προμηθευτής / Πάροχος', description: 'Περιγραφή',
      planned: 'Προγραμματισμένο', actual: 'Πραγματικό', status: 'Κατάσταση Πληρωμής', dueDate: 'Ημερομηνία Λήξης',
      categories: { Venue: 'Χώρος', Catering: 'Τροφοδοσία', Decoration: 'Διακόσμηση', Photography: 'Φωτογραφία', Entertainment: 'Ψυχαγωγία', Marketing: 'Μάρκετινγκ', Transportation: 'Μεταφορές', Accommodation: 'Διαμονή', Other: 'Άλλο' },
      paymentStatuses: { Planned: 'Προγραμματισμένο', Paid: 'Πληρώθηκε', PartiallyPaid: 'Μερικώς Πληρωμένο' }
    },
    summary: {
      title: 'Οικονομική Σύνοψη', incomeCard: 'Έσοδα', expensesCard: 'Έξοδα', resultCard: 'Αποτέλεσμα',
      plannedIncome: 'Προγραμματισμένα Έσοδα', actualIncome: 'Πραγματικά Έσοδα', incomeVariance: 'Απόκλιση Εσόδων',
      plannedExpenses: 'Προγραμματισμένα Έξοδα (προϋπολογισμός)', entryPlannedExpenses: 'Προγραμματισμένα Έξοδα (εγγραφές)',
      actualExpenses: 'Πραγματικά Έξοδα', expenseVariance: 'Απόκλιση Εξόδων', profitLoss: 'Κέρδος / Ζημία',
      budgetVariance: 'Απόκλιση Προϋπολογισμού', guestInsights: 'Στατιστικά Καλεσμένων', giftsCount: 'Δώρα που Ελήφθησαν',
      totalGifts: 'Σύνολο Δώρων', avgGift: 'Μέσο Δώρο', incomePerAttendee: 'Έσοδα ανά Παρευρισκόμενο', checkedIn: 'Καλεσμένοι που Παρευρέθηκαν'
    },
    errors: { loadFailed: 'Αποτυχία φόρτωσης οικονομικών δεδομένων.', saveFailed: 'Αποτυχία αποθήκευσης. Παρακαλώ δοκιμάστε ξανά.' }
  },
  eventMediaPage: {
    title: 'Πολυμέσα',
    mediaButton: 'Πολυμέσα',
    description: 'Συγκεντρώστε φωτογραφίες και βίντεο για αυτή την εκδήλωση.',
    upload: 'Μεταφόρτωση',
    empty: 'Δεν υπάρχουν ακόμα φωτογραφίες ή βίντεο.',
    premiumRequired: 'Η μεταφόρτωση πολυμέσων εκδήλωσης είναι λειτουργία Premium.',
    upgradeNow: 'Αναβάθμιση τώρα',
    select: 'Επιλογή',
    cancelSelect: 'Ακύρωση',
    downloadAll: 'Λήψη όλων',
    downloadSelected: 'Λήψη επιλεγμένων ({{count}})',
    uploadedBy: 'Από: {{name}}',
    errors: {
      loadFailed: 'Αποτυχία φόρτωσης πολυμέσων.',
      uploadFailed: 'Αποτυχία μεταφόρτωσης αρχείου. Παρακαλώ δοκιμάστε ξανά.',
      deleteFailed: 'Αποτυχία διαγραφής αρχείου. Παρακαλώ δοκιμάστε ξανά.',
      downloadFailed: 'Αποτυχία λήψης αρχείου. Παρακαλώ δοκιμάστε ξανά.',
      downloadZipFailed: 'Αποτυχία λήψης αρχείων. Παρακαλώ δοκιμάστε ξανά.'
    }
  },
  eventGalleryPage: {
    title: 'Gallery Καλεσμένων',
    galleryButton: 'Gallery Καλεσμένων',
    description: 'Επίτρεψε στους καλεσμένους σου να μοιραστούν τις δικές τους φωτογραφίες και βίντεο μετά την εκδήλωση, μέσω ενός κοινού link.',
    notEnabled: 'Το gallery καλεσμένων δεν έχει ενεργοποιηθεί ακόμα για αυτή την εκδήλωση.',
    enable: 'Ενεργοποίηση Gallery Καλεσμένων',
    enabling: 'Ενεργοποίηση...',
    linkLabel: 'Σύνδεσμος gallery',
    copyLink: 'Αντιγραφή συνδέσμου',
    linkCopied: 'Ο σύνδεσμος αντιγράφηκε.',
    expiresLabel: 'Οι καλεσμένοι μπορούν να ανεβάζουν έως',
    send: 'Αποστολή συνδέσμου στους καλεσμένους',
    sending: 'Αποστολή...',
    sendSuccess: 'Ο σύνδεσμος gallery στάλθηκε σε {{count}} καλεσμένο(ους).',
    premiumRequired: 'Το gallery καλεσμένων είναι λειτουργία Premium.',
    upgradeNow: 'Αναβάθμιση τώρα',
    disable: 'Απενεργοποίηση Gallery',
    disabling: 'Απενεργοποίηση...',
    disabledNotice: 'Το gallery καλεσμένων είναι αυτή τη στιγμή απενεργοποιημένο. Οι καλεσμένοι δεν μπορούν πλέον να βλέπουν ή να ανεβάζουν φωτογραφίες.',
    reEnable: 'Επανενεργοποίηση Gallery',
    viewModeAllPhotos: 'Οι καλεσμένοι βλέπουν όλες τις φωτογραφίες',
    errors: {
      loadFailed: 'Αποτυχία φόρτωσης ρυθμίσεων gallery.',
      enableFailed: 'Αποτυχία ενεργοποίησης του gallery καλεσμένων. Παρακαλώ δοκιμάστε ξανά.',
      sendFailed: 'Αποτυχία αποστολής του συνδέσμου gallery. Παρακαλώ δοκιμάστε ξανά.',
      disableFailed: 'Αποτυχία απενεργοποίησης του gallery καλεσμένων. Παρακαλώ δοκιμάστε ξανά.',
      viewModeFailed: 'Αποτυχία ενημέρωσης της ρύθμισης προβολής. Παρακαλώ δοκιμάστε ξανά.'
    }
  },
  eventWishlistPage: {
    title: 'Λίστα Επιθυμιών Δώρων',
    wishlistButton: 'Λίστα Επιθυμιών',
    description: 'Πρόσθεσε δώρα που μπορούν να επιλέξουν οι καλεσμένοι. Όσοι δηλώσουν παρουσία λαμβάνουν τη λίστα με e-mail.',
    addItem: 'Προσθήκη Δώρου',
    editItem: 'Επεξεργασία Δώρου',
    empty: 'Δεν έχουν προστεθεί δώρα ακόμα.',
    save: 'Αποθήκευση',
    cancel: 'Άκυρο',
    delete: 'Διαγραφή',
    addSuccess: 'Το «{{name}}» προστέθηκε στη λίστα επιθυμιών.',
    updateSuccess: 'Το «{{name}}» ενημερώθηκε.',
    deleteSuccess: 'Το «{{name}}» αφαιρέθηκε από τη λίστα επιθυμιών.',
    deleteConfirmTitle: 'Αφαίρεση δώρου;',
    deleteConfirmMessage: 'Είσαι σίγουρος ότι θέλεις να αφαιρέσεις το «{{name}}» από τη λίστα επιθυμιών;',
    table: {
      name: 'Όνομα',
      description: 'Περιγραφή',
      link: 'Σύνδεσμος',
      status: 'Κατάσταση',
      reservedBy: 'Δεσμεύτηκε από'
    },
    status: {
      available: 'Διαθέσιμο',
      pending: 'Εκκρεμεί επιβεβαίωση',
      confirmed: 'Δεσμευμένο'
    },
    form: {
      name: 'Όνομα δώρου',
      description: 'Σύντομη περιγραφή',
      purchaseUrl: 'Σύνδεσμος αγοράς'
    },
    errors: {
      loadFailed: 'Αποτυχία φόρτωσης της λίστας επιθυμιών.',
      saveFailed: 'Αποτυχία αποθήκευσης του δώρου. Παρακαλώ δοκιμάστε ξανά.',
      deleteFailed: 'Αποτυχία αφαίρεσης του δώρου. Παρακαλώ δοκιμάστε ξανά.'
    }
  },
  publicGallery: {
    title: 'Gallery Καλεσμένων',
    loading: 'Φόρτωση gallery...',
    subtitle: 'Φωτογραφίες και βίντεο από καλεσμένους της εκδήλωσης {{eventTitle}}',
    expiresNotice: 'Οι καλεσμένοι μπορούν να προσθέτουν φωτογραφίες/βίντεο έως {{date}}.',
    expiredNotice: 'Αυτό το gallery δεν δέχεται πλέον νέα uploads, αλλά μπορείς ακόμα να δεις όσα έχουν μοιραστεί.',
    disabledNotice: 'Αυτό το gallery έχει κλείσει από τον διοργανωτή.',
    ownUploadsNotice: 'Βλέπεις μόνο τις φωτογραφίες και τα βίντεο που ανέβασες από αυτή τη συσκευή.',
    uploaderLabelPlaceholder: 'Το όνομά σου (προαιρετικό)',
    upload: 'Προσθήκη φωτογραφίας/βίντεο',
    uploading: 'Μεταφόρτωση...',
    uploadDisclaimer: 'Ανεβάζοντας φωτογραφίες ή βίντεο εδώ, τα καθιστάς ορατά σε όλους τους καλεσμένους αυτής της εκδήλωσης. Βεβαιώσου ότι έχεις τη συναίνεση όποιου εμφανίζεται στο περιεχόμενο. Ο διοργανωτής μπορεί να αφαιρέσει οποιοδήποτε αρχείο ανά πάσα στιγμή.',
    empty: 'Δεν υπάρχουν ακόμα φωτογραφίες ή βίντεο. Μοιράσου πρώτος/η!',
    uploadedBy: 'Από: {{name}}',
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η σύνδεση με το backend API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      invalidGallery: 'Αυτός ο σύνδεσμος gallery είναι μη έγκυρος ή έχει λήξει.',
      loadGallery: 'Δεν ήταν δυνατή η φόρτωση αυτού του gallery αυτή τη στιγμή.',
      uploadFailed: 'Αποτυχία μεταφόρτωσης αρχείου. Παρακαλώ δοκιμάστε ξανά.'
    }
  },
  publicWishlist: {
    title: 'Λίστα Επιθυμιών Δώρων',
    loading: 'Φόρτωση λίστας...',
    subtitle: 'Ιδέες δώρων για {{eventTitle}}',
    empty: 'Δεν έχουν προστεθεί δώρα ακόμα.',
    viewLink: 'Δες το δώρο',
    reserve: 'Θα το πάρω εγώ',
    reserving: 'Δέσμευση...',
    release: 'Ακύρωση δέσμευσης',
    releasing: 'Ακύρωση...',
    reservedByMe: 'Δεσμεύσατε αυτό το δώρο. Ελέγξτε το e-mail σας για να το επιβεβαιώσετε μέσα σε 60 λεπτά.',
    confirmedByMe: 'Επιβεβαιώσατε αυτό το δώρο. Σας ευχαριστούμε!',
    unavailable: 'Έχει ήδη δεσμευτεί από άλλον καλεσμένο',
    attendingRequiredNotice: 'Μόνο καλεσμένοι που έχουν δηλώσει παρουσία μπορούν να δεσμεύσουν δώρο.',
    errors: {
      backendUnavailable: 'Δεν είναι δυνατή η σύνδεση με το backend API στο {{baseUrl}}. Εκκινήστε το API με: dotnet run --project src/Backend/EventList.Api',
      invalidInvitation: 'Αυτός ο σύνδεσμος είναι μη έγκυρος ή έχει λήξει.',
      loadFailed: 'Δεν ήταν δυνατή η φόρτωση της λίστας επιθυμιών αυτή τη στιγμή.',
      reserveFailed: 'Δεν ήταν δυνατή η δέσμευση αυτού του δώρου. Μπορεί να δεσμεύτηκε μόλις από κάποιον άλλον.',
      releaseFailed: 'Δεν ήταν δυνατή η ακύρωση της δέσμευσής σας αυτή τη στιγμή.'
    }
  },
  publicWishlistConfirm: {
    title: 'Επιβεβαίωση δέσμευσης δώρου',
    confirming: 'Επιβεβαίωση δέσμευσης...',
    successTitle: 'Η δέσμευση επιβεβαιώθηκε!',
    successMessage: 'Σας ευχαριστούμε! Η δέσμευσή σας για το «{{itemName}}» επιβεβαιώθηκε.',
    failureTitle: 'Αυτός ο σύνδεσμος δεν είναι πλέον έγκυρος',
    backToWishlist: 'Επιστροφή στη λίστα επιθυμιών'
  }
};

export default el;
